import React from 'react';
import recordingOnSvg from 'src/images/AR_record_dot.svg';
import recordingOnBlinkSvg from 'src/images/AR_record_no_dot.svg';
import { BlinkingSvg } from './blinking-svg';
import { Icon } from '@hai/ui-react';
import { recordIsRunning, streamIsStopped, StreamViewModel } from '../pages/streaming/stream/stream-models';

export interface RecordingIconProps {
  model: StreamViewModel;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | string;
  style?: React.CSSProperties;
  onClick?: () => void;
  pulsing?: boolean;
  running: boolean;
  alt?: string;
  text: string;
  textColor?: string;
  diskFull: boolean;
}

export const RecordingIconDot: React.FC<RecordingIconProps> = ({
  model,
  className = '',
  size = 'md',
  style,
  onClick,
  pulsing = false,
  running,
  alt = 'Recording',
  text,
  textColor,
  diskFull,
}) => {
  const getSizeStyles = (sizeValue: string) => {
    switch (sizeValue) {
      case 'sm':
        return { width: '16px', height: 'auto' };
      case 'md':
        return { width: '24px', height: 'auto' };
      case 'lg':
        return { width: '32px', height: 'auto' };
      default:
        return { width: sizeValue, height: 'auto' };
    }
  };

  const combinedStyle = {
    ...getSizeStyles(size),
    ...style,
  };

  const streamStopped = streamIsStopped(model.state);

  const pulsingClass = pulsing ? 'pulsing' : '';
  const combinedClassName = `recording-icon-dot ${pulsingClass} ${className}`.trim();

  return (
    <div className="mk-recording-icon">
      {running ? (
        <BlinkingSvg
          src1={recordingOnSvg}
          src2={recordingOnBlinkSvg}
          alt={alt}
          className={combinedClassName}
          style={combinedStyle}
          onClick={onClick}
          // color={color} color cannot be changed on SVG with our loader
        />
      ) : (
        <Icon
          className={(diskFull || model.recording.status === 'HALTED') && 'amber-svg'}
          iconname={
            streamStopped
              ? 'Record'
              : diskFull || model.recording.status === 'HALTED'
              ? 'StatusWarning'
              : recordIsRunning(model.recording)
              ? 'Record'
              : model.recording.status === 'STOPPED'
              ? 'RecordStopped'
              : 'Record'
          }
          color={textColor}
          size="sm3"
        />
      )}
      <div className="mk-companion-text" style={{ '--text-color': textColor } as React.CSSProperties}>
        {text}
      </div>
    </div>
  );
};
